var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.name,
                  expression: "formData.name",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "name",
                name: "name",
                placeholder: "Enter a name for your Insight...",
                required: "",
              },
              domProps: { value: _vm.formData.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "name" } },
              [_vm._v("Insight name")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("name"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlSector", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "sectors", multiple: true },
            model: {
              value: _vm.formData.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "sectors", $$v)
              },
              expression: "formData.sectors",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }